import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';


@Injectable()
export class HomeService {

    constructor(private httpClient: HttpClient) {
    }

    saveToGoogleSpreadSheet(data) {
        const action = "https://script.google.com/macros/s/AKfycbzAeOi4LC8iygt5KOs0EDAxPRAmNK_0_O4q7P6oz4f3qVnBPh_LdG4KScOwxnxLybtXog/exec";

        const formData: any = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (data[key] != '') {
                    formData.append(key, data[key]);
                }
            }
        }
        return this.httpClient.post<any>(action, formData);
    }

}

